import React, { useEffect, useState } from "react";
import { Card, CardBody, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RoomService } from "./service";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import DeleteModal from "../../Common/DeleteModal";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const RoomList = () => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [term, setTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState<number | null>(null);
  const navigate = useNavigate();

  const entriesPerPageOptions = [
    { label: "10", value: 10 },
    { label: "25", value: 25 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
    { label: "200", value: 200 },
  ];

  const handleTermChange = (e: any) => {
    setTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleEntriesPerPageChange = (selectedOption: any) => {
    setEntriesPerPage(selectedOption ? selectedOption.value : 10);
    setCurrentPage(1);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handleDeleteClick = (id: number) => {
    setRoomToDelete(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (roomToDelete !== null) {
      try {
        await RoomService.delete(roomToDelete);
        SuccessToast(t("room.successDelete"));
        setShowDeleteModal(false);
        setRoomToDelete(null);
        fetchData();
      } catch (error) {
        ErrorToast(error);
      }
    }
  };

  const fetchData = async () => {
    try {
      const response = await RoomService.getAll({
        page: currentPage,
        perPage: entriesPerPage,
        term,
      });
      const data = response.data;
      setList(data);
      setTotalPages(response.totalPages);
    } catch (error) {
      ErrorToast(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, entriesPerPage, term]);
  console.log(list)
  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody className="card-body">
            <div className="text-end">
              <button
                className="btn btn-primary text-end"
                onClick={() => navigate("/rooms/create")}
              >
                <i className="ti ti-plus f-18"></i> {t("room.add")}
              </button>
            </div>

            <div className="d-sm-flex align-items-center mb-3">
              <ul className="list-inline me-auto my-1">
                <li className="list-inline-item">
                  <Select
                    placeholder={t("room.entriesPerPage")}
                    options={entriesPerPageOptions}
                    onChange={handleEntriesPerPageChange}
                    defaultValue={entriesPerPageOptions.find(
                      (option) => option.value === entriesPerPage,
                    )}
                    classNamePrefix="react-select"
                  />
                </li>
                <span> {t("room.entriesPerPage")}</span>
              </ul>
              <ul className="list-inline ms-auto my-1 mt-3">
                <li className="list-inline-item">
                  <form className="">
                    <input
                      className="form-control"
                      type="search"
                      placeholder={t("room.searchPlaceholder")}
                      onChange={handleTermChange}
                    />
                  </form>
                </li>
              </ul>
            </div>
            <div className="table-responsive">
              <table className="table table-hover" id="pc-dt-simple-1">
                <thead>
                  <tr>
                    <th>{t("room.id")}</th>
                    <th>{t("room.name")}</th>
                    <th>{t("room.flat")}</th>
                    <th>{t("room.createdAt")}</th>
                    <th>{t("room.updatedAt")}</th>
                    <th className="text-end">{t("room.actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>{item.id}</td>
                      <td>{item?.roomName?.name || item?.name || "-"}</td>
                      <td>{item.flat?.name}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      <td>{new Date(item.updatedAt).toLocaleDateString()}</td>
                      <td className="text-end">
                        <ul className="list-inline mb-0">
                          <li
                            className="list-inline-item"
                            onClick={() => navigate(`/rooms/edit/${item.id}`)}
                          >
                            <a
                              href="#"
                              className="avtar avtar-s btn-link-success btn-pc-default"
                            >
                              <i className="ti ti-edit f-20"></i>
                            </a>
                          </li>
                          <li className="list-inline-item">
                            <span
                              role="button"
                              className="avtar avtar-s btn-link-danger btn-pc-default"
                              onClick={() => handleDeleteClick(item.id)}
                            >
                              <i className="ti ti-trash f-20"></i>
                            </span>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <ul className="pagination justify-content-end me-3 mt-2 mb-0">
              <li
                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
              >
                <button className="page-link" onClick={goToPreviousPage}>
                  {t("room.previous")}
                </button>
              </li>
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li
                className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
              >
                <button className="page-link" onClick={goToNextPage}>
                  {t("room.next")}
                </button>
              </li>
            </ul>
          </CardBody>
        </Card>
      </Col>

      <DeleteModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleDeleteId={handleDeleteConfirm}
        name={t("room.name")}
      />
    </React.Fragment>
  );
};

export default RoomList;
